<div class="flex items-center gap-2">

  <button (click)="toggleFav.emit()" [class.w-7]="mobile()" [class.h-7]="mobile()" [class.w-10]="!mobile()"
    [class.h-10]="!mobile()" class="rounded-full border border-gray-200 flex items-center justify-center">

    <sham-i-Heart [class.*:size-4]="mobile()" [class.*:size-5]="!mobile()" [class.*:fill-[#EC5A7A]]="favorite()"
      [class.*:fill-[#ffffff]]="!favorite()" />

  </button>

  <button   *ngIf="!isCheckout()"
 (click)="remove.emit()" [class.w-7]="mobile()" [class.h-7]="mobile()" [class.w-10]="!mobile()"
    [class.h-10]="!mobile()" class="rounded-full border border-gray-200 flex items-center justify-center">

    <sham-i-fi_x [class.*:size-4]="mobile()" [class.*:size-5]="!mobile()" class="*:stroke-[#919191]" />

  </button>

</div>
